
<button type="button" class="card" (click)="filterCardClick()">
    <p class="tip">{{title}}</p>
</button>